import React from "react";

interface DatePriceTabsProps {
    currentDate: string;
    basePrice: number;
    currency?: string;
}

const DatePriceTabs: React.FC<DatePriceTabsProps> = ({
    currentDate,
    basePrice,
    currency = "€",
}) => {
    // Parse the current date
    const date = new Date(currentDate);

    // Generate yesterday and tomorrow dates
    const yesterday = new Date(date);
    yesterday.setDate(date.getDate() - 1);

    const tomorrow = new Date(date);
    tomorrow.setDate(date.getDate() + 1);

    // Format date as "WED 24 SEP"
    const formatDate = (dateObj: Date) => {
        const days = ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"];
        const months = [
            "JAN",
            "FEB",
            "MAR",
            "APR",
            "MAY",
            "JUN",
            "JUL",
            "AUG",
            "SEP",
            "OCT",
            "NOV",
            "DEC",
        ];

        const dayName = days[dateObj.getDay()];
        const dayNum = dateObj.getDate();
        const monthName = months[dateObj.getMonth()];

        return `${dayName} ${dayNum} ${monthName}`;
    };

    // Generate random price variations (±15-25%)
    const generateRandomPrice = (base: number) => {
        const variation = 0.15 + Math.random() * 0.1; // 15-25% variation
        const direction = Math.random() > 0.5 ? 1 : -1;
        const newPrice = base * (1 + direction * variation);
        return newPrice.toFixed(2).replace(".", ","); // European format
    };

    const yesterdayPrice = generateRandomPrice(basePrice);
    const todayPrice = basePrice.toFixed(2).replace(".", ",");
    const tomorrowPrice = generateRandomPrice(basePrice);

    return (
        <div className="flex items-stretch">
            {/* Yesterday tab */}
            <div className="px-2.5 py-3 text-center cursor-pointer bg-[#c1e5f5] hover:bg-[#b0daf0] transition-colors rounded-tl-lg">
                <div className="text-xs text-gray-700 font-medium">
                    {formatDate(yesterday)}
                </div>
                <div className="text-sm font-bold text-[#000066]">
                    {currency}
                    {yesterdayPrice}
                </div>
            </div>

            {/* Today tab - selected */}
            <div className="mx-1 px-2.5 py-3 -mt-2 text-center bg-[#d9d9d9] border-x border-gray-300 rounded-t-lg">
                <div className="text-xs text-gray-700 font-medium">
                    {formatDate(date)}
                </div>
                <div className="text-sm font-bold text-[#000066]">
                    {currency}
                    {todayPrice}
                </div>
            </div>

            {/* Tomorrow tab */}
            <div className="px-2.5 py-3 text-center cursor-pointer bg-[#c1e5f5] hover:bg-[#b0daf0] transition-colors rounded-tl-lg">
                <div className="text-xs text-gray-700 font-medium">
                    {formatDate(tomorrow)}
                </div>
                <div className="text-sm font-bold text-[#000066]">
                    {currency}
                    {tomorrowPrice}
                </div>
            </div>
        </div>
    );
};

export default DatePriceTabs;
